import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSend = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_4924_46056)",
			children: [/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.4457 0.554199L11.6647 19.7397L8.14118 11.8587L0.260254 8.33522L19.4457 0.554199ZM2.30046 8.37106L8.74674 11.2532L11.6288 17.6995L17.9934 2.0065L2.30046 8.37106Z"
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.16113 11.2731L18.4367 0.997559L19.0024 1.56324L8.72681 11.8389L8.16113 11.2731Z"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4924_46056",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgSend);
export default ForwardRef;
